export const ownershipSelectOptions = [
  { name: 'Choose from the following', value: '' },
  { name: 'One founder owns 100%', value: 'one-founder-100' },
  { name: '2 founders own shares', value: '2-founders' },
  {
    name: '3 or more founders own shares',
    value: '3-or-more-founders',
  },
  {
    name: 'Founders own shares and investors own shares',
    value: 'founders-and-investors',
  },
];

export const tractionSelectOptions = [
  { name: 'Select from the following', value: '' },
  { name: 'No users/clients yet', value: 'no-users-clients-yet' },
  { name: 'Users/Clients but no revenue', value: 'users-clients-no-revenue' },
  { name: 'Revenue exists', value: 'revenue-exists' },
];

export const expectedTractionSelectOptions = [
  { name: 'Select status of revenue expectations', value: '' },
  { name: 'Less than 3 Months', value: 'less-than-3-months' },
  { name: '3-6 Months', value: '3-6-months' },
  { name: '6-12 Months', value: '6-12-months' },
  { name: '1-2 Years', value: '1-2-years' },
  { name: 'Over 2 Years', value: 'over-2-years' },
];
